import { FieldModel } from '@cibo/core'
import { AmendmentCellDisplay } from '@cibo/landmanager'
import { TraitCellContainer } from './TraitCellContainer'

interface AmendmentCellProps {
  value: any
  task: any
  year: number
  selectedField: FieldModel | null
}

export const AmendmentCell = ({ value, task, year, selectedField }: AmendmentCellProps) => {
  return (
    <TraitCellContainer
      value={value}
      task={task}
      selectedField={selectedField}
      year={year}
      traitId="amendment"
    >
      <AmendmentCellDisplay value={value} />
    </TraitCellContainer>
  )
}
